
<div class="container">
  <div class="row mt-2">
    <div class="col-sm-12">
      <div class="alert alert-success" [hidden]="remainingAssets &gt; 0">All assets have a serial number and MAC address.</div>
      <div class="alert alert-warning" [hidden]="remainingAssets &lt;= 0">{{remainingAssets}} asset(s) without serial number or MAC address.</div>
      <error [error]="error"></error>
    </div>
  </div>
  <div class="form" [formGroup]="assetDetailDatesForm">
    <div class="row mt-2 justify-content-md-center">
      <div class="col-md-10 card-block">
        <div class="row">
          <div class="col-md-6">
            <div class="inline-block">
              <label for="targetDeliveryDateText">Target Delivery Date (TDD)
                <help-dialog-button fieldName="Target Delivery Date (TDD)" helpString="Date displayed will reflect delivery date as predicted by S4"></help-dialog-button>
              </label>
            </div>
            <div class="input-group">
              <input class="form-control" id="targetDeliveryDateText" formControlName="targetDeliveryDate" type="text" [value]="assetDetailDatesForm.value.targetDeliveryDate">
              <datepicker class="right input-group-append" formControlName="targetDeliveryDate" [value]="assetDetailDatesForm.value.targetDeliveryDate"></datepicker>
            </div>
          </div>
          <div class="col-md-6">
            <div class="inline-block">
              <label for="actualDeliveryDateText">Actual Delivery Date
                <help-dialog-button fieldName="Actual Delivery Date" helpString="Delivery date from SANDY"></help-dialog-button>
              </label>
            </div>
            <div class="input-group">
              <input class="form-control" id="actualDeliveryDateText" formControlName="actualDeliveryDate" type="text" [value]="assetDetailDatesForm.value.actualDeliveryDate">
              <datepicker class="right input-group-append" formControlName="actualDeliveryDate" [value]="assetDetailDatesForm.value.actualDeliveryDate"></datepicker>
            </div>
          </div>
          <div class="col-md-6 mt-3">
            <div class="inline-block">
              <label for="estimatedDeliveryFullDateText">Estimated Delivery in Full
                <help-dialog-button fieldName="Estimated Delivery in Full" helpString="Estimated date the order will deliver in full"></help-dialog-button>
              </label>
            </div>
            <div class="input-group">
              <input class="form-control" id="estimatedDeliveryFullDateText" formControlName="estimatedDeliveryFullDate" type="text" [value]="assetDetailDatesForm.value.estimatedDeliveryFullDate">
              <datepicker class="right input-group-append" formControlName="estimatedDeliveryFullDate" [value]="assetDetailDatesForm.value.estimatedDeliveryFullDate"></datepicker>
            </div>
          </div>
          <div class="col-md-6 mt-3">
            <div class="inline-block">
              <label for="actualDeliveryFullDateText">Actual Delivery in Full
                <help-dialog-button fieldName="Actual Delivery in Full" helpString="Actual date the order will deliver in full; final delivery date if split order "></help-dialog-button>
              </label>
            </div>
            <div class="input-group">
              <input class="form-control" id="actualDeliveryFullDateText" formControlName="actualDeliveryFullDate" type="text" [value]="assetDetailDatesForm.value.actualDeliveryFullDate">
              <datepicker class="right input-group-append" formControlName="actualDeliveryFullDate" [value]="assetDetailDatesForm.value.actualDeliveryFullDate"></datepicker>
            </div>
          </div>
          <div class="col-12 mt-3">
            <button class="btn btn-outline-primary float-right" (click)="saveDates()">Save</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-sm-8">
      <p>Update assets serial number and MAC address, filling in the table or uploading a file</p>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col table-card">
      <list-controls [showSearch]="false" [limit]="pageSize" [page]="currentPage" [numPages]="maxPages" [totalCount]="totalCount" (onChange)="onListControlsChange($event)">
        <button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown">Actions</button>
        <div class="dropdown-menu dropdown-menu-right"><a class="dropdown-item" href="javascript:void(0);" (click)="save()">Save</a><a class="dropdown-item" [downloadFile]="'/api/orderworkflow/export-assets/' + orderId"><span class="oi oi-cloud-download"></span> Export Assets</a><a class="dropdown-item" [uploadFileTo]="'/api/orderworkflow/import-assets/' + orderId" [fileExtensions]="['xls', 'xlsx', 'xlsm', 'xlsb']" (closed)="completed($event)"><span class="oi oi-cloud-upload"></span> Import Assets</a><a class="dropdown-item" [href]="'/#/sandy-import?orderId=' + orderId" target="_blank"><span class="oi oi-external-link"></span> Import OSS/Sandy File</a></div>
      </list-controls>
      <table class="table table-responsive">
        <thead>
          <tr class="table-header-with-controls">
            <th>Model & Info</th>
            <th>Map ID</th>
            <th>Serial Number</th>
            <th>MAC Address</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let asset of assets">
            <td><span class="badge badge-secondary mr-2" *ngIf="asset.quicksilver">QS</span><span>{{ asset.productDescription }} <b>({{ asset.productNumber }})</b></span><br><span>Device Key: {{ asset.deviceKey }}</span><span *ngIf="!!asset.building"><br />Building: {{ asset.building }}</span><span *ngIf="!!asset.floor"><br />Floor: {{ asset.floor }}</span></td>
            <td>{{ asset.floorMapId }}</td>
            <td>
              <input class="form-control" type="text" [(ngModel)]="asset.newSerialNumber" maxlength="20" style="min-width: 120px;">
            </td>
            <td>
              <input class="form-control" type="text" [(ngModel)]="asset.newMacAddress" maxlength="20" style="min-width: 120px;">
            </td>
          </tr>
          <tr *ngIf="assets.length === 0">
            <td colspan="4">
              <p class="text-center empty-table-message">There are no assets to display.</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>